

































































































































































































import { UserModule } from '@/store/modules/user';
import { AppModule } from '@/store/modules/app';
import SelectGroup from '@/components/Common/SelectGroup.vue';
import SearchGroup from '@/components/Common/SearchGroup.vue';
import SelectPageSearch from '@/components/Common/SelectPageSearch.vue';
import CourseApplicationList from './components/courseApplication/CourseApplicationList.vue';
import CourseApplicationSearchDisplay from './components/courseApplication/CourseApplicationSearchDisplay.vue';
import { Component, Vue, Watch } from 'vue-property-decorator';
import {
  getCourseToIssueApi,
  getCountryToIssueApi,
  getInstitutionDataApi,
  getIssueMajorLevelListApi,
  getGearStuApplyListByOfferItemApi,
  getIsGearStuApplyListByOfferItemExcelApi,
  exportGearStuApplyListByOfferItemExcelApi,
} from '@/api/index';
import {
  getStuDataApi,
  getAppCountryApi,
  getApplicationStatusApi,
  getStudentCreateUserIdListApi,
} from '@/api/student-management';
import { debounce, getPickerOptions } from '@/utils/function_utils';
import { IReqFilterTable, ApplicationListFilter } from '@/interface/common';

@Component({
  name: 'applicationList',
  components: {
    SelectGroup,
    SearchGroup,
    SelectPageSearch,
    CourseApplicationList,
    CourseApplicationSearchDisplay,
  }
})

export default class extends Vue {
  get year() {
    return UserModule.indexSelectYear;
  }

  get language() {
    return AppModule.language;
  }

  public updateData = false;
  public showQueryDisplay = false;
  public activeName = 'applicationList';
  public countryOptions: any[] = [];
  public changeStepIdOptions: any[] = [];
  public fkMajorLevelOptions: any[] = [];
  public fkInstitutionOptions: any[] = [];
  public gmtCreateUserIdOptions: any[] = [];
  public applicationCountryOptions: any[] = [];
  public fkInstitutionCourseOptions: any[] = [];
  public tableData: any[] = [];
  public tablePage: IReqFilterTable<ApplicationListFilter> = {
    currentPage: 1, // 查询页码
    showCount: 20, // 显示条目数
    totalResult: 0, // 总数
  }
  public reqFilter: ApplicationListFilter = {
    keyWord: '',
    applyAreaCountryId: '',
    openTimeStart: '',
    openTimeEnd: '',
    statusBeginTime: '',
    statusEndTime: '',
    statusDays: '',
    fkAreaCountryId: '',
    fkInstitutionId: '',
    fkMajorLevelId: '',
    fkInstitutionCourseId: '',
    submitStartTime: '',
    submitEndTime: '',
    createStartTime: '',
    createEndTime: '',
    openTimeRange: [],
    statusTimeRange: [],
    submitTimeRange: [],
    createTimeRange: [],
    changeStepIds: [],
    gmtCreateUserIds: [],
    applyAreaCountryIdName: '',
    fkAreaCountryIdName: '',
    changeStep: [],
    gmtCreateUser: [],
    fkInstitutionIdName: '',
    fkInstitutionCourseIdName: '',
    fkMajorLevelIdName: '',
    orderBy: '', // 正序：asc,倒叙：descs
    orderByColumns: '',
  }

  public pickerOptions = getPickerOptions();

  // 利用防抖避免连续多次点击发送多次请求
  public getTables = debounce(this.getTableDatas, 500);

  @Watch('language', { immediate: true })
  public onLanguageChange() {
    const lastWeek = this.$t('common.lastWeek');
    const lastMonth = this.$t('common.lastMonth');
    const lastThreeMonths = this.$t('common.lastThreeMonths');
    this.pickerOptions.shortcuts[0].text = lastWeek;
    this.pickerOptions.shortcuts[1].text = lastMonth;
    this.pickerOptions.shortcuts[2].text = lastThreeMonths;
  }

  @Watch('year')
  public onYearChange(newVal: string) {
    if (newVal !== '0' && newVal) {
      this.reqFilter.createStartTime = newVal + '-01-01';
      this.reqFilter.createEndTime = newVal + '-12-31';
      this.reqFilter.createTimeRange = [newVal + '-01-01', newVal + '-12-31'];
    } else if (newVal === '0') {
      this.getTables();
      this.reqFilter.createStartTime = '';
      this.reqFilter.createEndTime = '';
      this.reqFilter.createTimeRange = [];
    }
  }

  @Watch('$route.query', { deep: true })
  public onRouteChange(query: any) {
    if (Object.keys(query).length) {
      this.setQueryParams();
      this.getTableDatas();
    }
  }

  public async mounted() {
    this.setQueryParams();
    this.getCountryOptions();
    this.getCountryToIssue();
    this.getIssueMajorLevelList();
    this.getGmtCreateUserIdOptions();
    if (!this.changeStepIdOptions.length) {
      await this.getChangeStepOptions();
    }
    this.getTables()
  }

  public async setQueryParams() {
    const query = this.$route.query;
    if (query.stepId) {
      const stepIds: string = query.stepId as string;
      if (stepIds.includes(',')) {
        this.reqFilter.changeStepIds = stepIds.split(',').map((item: string) => Number(item));
      } else {
        this.reqFilter.changeStepIds = [Number(query.stepId)];
      }
      await this.getChangeStepOptions();
    }
    if (query.year && query.year !== '0') {
      this.reqFilter.createStartTime = query.year + '-01-01';
      this.reqFilter.createEndTime = query.year + '-12-31';
      this.reqFilter.createTimeRange = [query.year + '-01-01', query.year + '-12-31']
    }
    if (query.startTime) {
      const startTime: string = query.startTime as string;
      const endTime: string = query.endTime as string
      this.reqFilter.createStartTime = startTime;
      this.reqFilter.createEndTime = endTime;
      this.reqFilter.createTimeRange = [startTime, endTime]
    }
    if (query.keyword) {
      this.reqFilter.keyWord = query.keyword as string;
    }
    if (query.ctryId) {
      this.reqFilter.applyAreaCountryId = Number(query.ctryId);
      this.reqFilter.applyAreaCountryIdName = query.ctry as string;
    }
    if (query.schId) {
      this.reqFilter.fkInstitutionId = Number(query.schId);
      this.reqFilter.fkInstitutionIdName = query.sch as string;
      this.getInstitutionData(Number(query.ctryId))
    }
    if (query.schId || query.stepId || (query.year && query.year !== '0') || query.startTime || query.keyword || query.ctryId) {
      this.showQueryDisplay = true;
      this.updateData = true;
    }
  }

  public async getCountryToIssue() {
    const { data } = await getCountryToIssueApi();
    this.applicationCountryOptions = data.datas || [];
  }

  public async getCountryOptions() {
    const { data } = await getAppCountryApi();
    this.countryOptions = data.datas || [];
  }

  // 获取申请状态下拉
  public async getChangeStepOptions() {
    const { data } = await getApplicationStatusApi();
    this.changeStepIdOptions = data.datas;
    if (this.reqFilter.changeStepIds.length) {
      this.changeSteps(this.reqFilter.changeStepIds);
    }
  }

  public async getGmtCreateUserIdOptions() {
    const { data }: any = await getStudentCreateUserIdListApi();
    this.gmtCreateUserIdOptions = data.datas || [];
  }

  public async getTableDatas() {
    const params = Object.assign({}, { data: this.reqFilter }, this.tablePage);
    const { data } = await getGearStuApplyListByOfferItemApi(params);
    this.tableData = data.datas;
    this.tablePage = Object.assign(this.tablePage, data.page);
    if (this.updateData) {
      this.updateData = false;
    }
  }

  public async getCourseToIssue(fkInstitutionId: number | string, fkMajorLevelId: number | string) {
    const { data } = await getCourseToIssueApi(fkInstitutionId, fkMajorLevelId);
    this.fkInstitutionCourseOptions = data.datas || [];
  }

  public async getIssueMajorLevelList() {
    const { data } = await getIssueMajorLevelListApi();
    this.fkMajorLevelOptions = data.datas || [];
  }

  public async getInstitutionData(countryId: number) {
    const { data } = await getInstitutionDataApi(countryId);
    this.fkInstitutionOptions = data.datas || [];
  }

  public resetPageInfo() {
    this.tablePage = {
      showCount: 20,
      currentPage: 1,
      totalResult: 0,
    }
  }

  public async handleExport() {
    const reqData = Object.assign({}, this.reqFilter);
    try {
      const { data } = await getIsGearStuApplyListByOfferItemExcelApi(reqData);
      if (!data.data) {
        this.$message.error(this.$t('index.exportNoDataTips') as string);
        return;
      }
      exportGearStuApplyListByOfferItemExcelApi(reqData).then((res) => {
        const blob = new Blob([res.data], { type: 'application/vnd.ms-excel;charset=utf-8' });
        const navigator: any = window.navigator;
        const nowTime = new Date().toLocaleString();
        const fileName = this.$t('index.applicationList') + nowTime;
        if (navigator.msSaveOrOpenBlob) { // 兼容IE10
          navigator.msSaveBlob(blob, fileName);
        } else {
            const href = URL.createObjectURL(blob); // 创建新的URL表示指定的blob对象
            const a = document.createElement('a'); // 创建a标签
            document.body.appendChild(a);
            a.style.display = 'none';
            a.href = href; // 指定下载链接
            a.download = fileName + '.xls' // 指定下载文件名
            a.click(); // 触发下载
            URL.revokeObjectURL(a.href); // 释放URL对象
        }
      })
    } catch(e) {
      return;
    }
  }

  public handleReset() {
    this.reqFilter = {
      keyWord: '',
      applyAreaCountryId: '',
      openTimeStart: '',
      openTimeEnd: '',
      statusBeginTime: '',
      statusEndTime: '',
      statusDays: '',
      fkAreaCountryId: '',
      fkInstitutionId: '',
      fkMajorLevelId: '',
      fkInstitutionCourseId: '',
      submitStartTime: '',
      submitEndTime: '',
      createStartTime: '',
      createEndTime: '',
      openTimeRange: [],
      statusTimeRange: [],
      submitTimeRange: [],
      createTimeRange: [],
      gmtCreateUserIds: [],
      changeStepIds: [],
      applyAreaCountryIdName: '',
      fkAreaCountryIdName: '',
      gmtCreateUser: [],
      changeStep: [],
      fkInstitutionIdName: '',
      fkInstitutionCourseIdName: '',
      fkMajorLevelIdName: '',
      orderBy: '', // 正序：asc,倒叙：descs
      orderByColumns: '',
    }
    this.fkInstitutionOptions = [];
    this.fkInstitutionCourseOptions = [];
    this.showQueryDisplay = false;
    this.resetPageInfo();
    this.getTables();
  }

  public clearSearch(key: string) {
    const reqFilter: any = this.reqFilter;
    if (['gmtCreateUser', 'changeStep'].includes(key)) {
      reqFilter[key+'Ids'] = [];
      reqFilter[key] = [];
    } else if (key.includes('IdName')) {
      if (key === 'applyAreaCountryIdName') {
        this.changeApplyAreaCountry('');
      } else if (key === 'fkInstitutionIdName') {
        this.changeInstitutionName('');
      } else if (key === 'fkMajorLevelIdName') {
        this.changeMajorLevel('');
      } else {
        reqFilter[key] = '';
        reqFilter[key.replace('IdName', 'Id')] = '';
      }
    } else if (key.includes('TimeRange')) {
      if (key === 'openTimeRange') {
        reqFilter.openTimeStart = '';
        reqFilter.openTimeEnd = '';
        reqFilter.openTimeRange = [];
      } else if (key === 'statusTimeRange') {
        reqFilter.statusBeginTime = '';
        reqFilter.statusEndTime = '';
        reqFilter.statusTimeRange = [];
      } else if (key === 'submitTimeRange') {
        reqFilter.submitStartTime = '';
        reqFilter.submitEndTime = '';
        reqFilter.submitTimeRange = [];
      } else if (key === 'createTimeRange') {
        reqFilter.createStartTime = '';
        reqFilter.createEndTime = '';
        reqFilter.createTimeRange = [];
      }
    } else {
      reqFilter[key] = '';
    }
    this.getTables();
  }

  public handleSearch() {
    this.reqFilter.orderBy = '';
    this.reqFilter.orderByColumns = '';
    this.showQueryDisplay = true;
    this.updateData = true;
    this.resetPageInfo();
    this.getTables();
  }

  public handleCreateTimeChange(rangeDate: any) {
    if (!rangeDate) {
      this.reqFilter.createStartTime = '';
      this.reqFilter.createEndTime = '';
      return;
    }
    this.reqFilter.createStartTime = rangeDate[0] || '';
    this.reqFilter.createEndTime = rangeDate[1] || '';
  }

  public handleStatusTimeChange(rangeDate: any) {
    if (!rangeDate) {
      this.reqFilter.statusBeginTime = '';
      this.reqFilter.statusEndTime = '';
      return;
    }
    this.reqFilter.statusBeginTime = rangeDate[0] || '';
    this.reqFilter.statusEndTime = rangeDate[1] || '';
  }

  public handleOpenTimeChange(rangeDate: any) {
    if (!rangeDate) {
      this.reqFilter.openTimeStart = '';
      this.reqFilter.openTimeEnd = '';
      return;
    }
    this.reqFilter.openTimeStart = rangeDate[0] || '';
    this.reqFilter.openTimeEnd = rangeDate[1] || '';
  }

  public handleSubmitTimeChange(rangeDate: any) {
    if (!rangeDate) {
      this.reqFilter.submitStartTime = '';
      this.reqFilter.submitEndTime = '';
      return;
    }
    this.reqFilter.submitStartTime = rangeDate[0] || '';
    this.reqFilter.submitEndTime = rangeDate[1] || '';
  }

  public changeCountry(value: any) {
    if (!value) {
      this.reqFilter.fkAreaCountryIdName = '';
      this.reqFilter.fkAreaCountryId = '';
      return;
    };
    const item = this.countryOptions.find((option: any) => option.id === value);
    this.reqFilter.fkAreaCountryIdName = item ? item.name : '';
  }

  public changeApplyAreaCountry(value: any) {
    this.reqFilter.fkInstitutionId = '';
    this.reqFilter.fkInstitutionIdName = '';
    this.reqFilter.fkInstitutionCourseId = '';
    this.reqFilter.fkInstitutionCourseIdName = '';
    if (!value) {
      this.reqFilter.applyAreaCountryId = '';
      this.reqFilter.applyAreaCountryIdName = '';
      this.fkInstitutionOptions = [];
      this.fkInstitutionCourseOptions = [];
      return;
    };
    this.getInstitutionData(value);
    const item = this.applicationCountryOptions.find((option: any) => option.id === value);
    this.reqFilter.applyAreaCountryIdName = item ? item.name : '';
  }
  public handleInstitutionSelectBlur() {
    if (!this.reqFilter.applyAreaCountryId) {
      this.$message.error(this.$t('message.selectInstitutionMessage') as string);
    }
  }

  public changeInstitutionName(value: any) {
    this.reqFilter.fkInstitutionCourseId = '';
    this.reqFilter.fkInstitutionCourseIdName = '';
    if (!value) {
      this.reqFilter.fkInstitutionId = '';
      this.reqFilter.fkInstitutionIdName = '';
      this.fkInstitutionCourseOptions = [];
      return;
    };
    this.reqFilter.fkInstitutionId = value;
    if (this.reqFilter.fkMajorLevelId) {
      this.getCourseToIssue(value, this.reqFilter.fkMajorLevelId);
    }
    const item = this.fkInstitutionOptions.find((option: any) => option.id === value);
    this.reqFilter.fkInstitutionIdName = item ? item.name : '';
  }

  public changeMajorLevel(value: any) {
    this.reqFilter.fkInstitutionCourseId = '';
    this.reqFilter.fkInstitutionCourseIdName = '';
    if (!value) {
      this.reqFilter.fkMajorLevelId = '';
      this.reqFilter.fkMajorLevelIdName = '';
      this.fkInstitutionCourseOptions = [];
      return;
    };
    if (this.reqFilter.fkInstitutionId) {
      this.getCourseToIssue(this.reqFilter.fkInstitutionId, value);
    }
    for (const element of this.fkMajorLevelOptions) {
      const item = element.majorLevelDtoList.find((option: any) => option.id === value);
      if (item) {
        this.reqFilter.fkMajorLevelIdName = item ? item.levelName : '';
        break;
      }
    }
  }

  public changeInstitutionCourse(value: any) {
    if (!value) {
      this.reqFilter.fkInstitutionCourseId = '';
      this.reqFilter.fkInstitutionCourseIdName = '';
      return;
    };
    const item = this.fkInstitutionCourseOptions.find((option: any) => option.id === value);
    this.reqFilter.fkInstitutionCourseIdName = item ? item.name : '';
  }

  public changeSteps(values: any) {
    if (!values.length) {
      this.reqFilter.changeStep = [];
      return;
    };
    const stepNames: any = [];
    this.changeStepIdOptions.map((item: any) => {
      const target = values.find((value: number) => item.id === value);
      if (target) {
        stepNames.push(item.stepName);
      }
    })
    this.reqFilter.changeStep = stepNames;
  }

  public changeUsers(values: any) {
    if (!values.length) {
      this.reqFilter.gmtCreateUser = [];
      return;
    };
    const users: any = [];
    this.gmtCreateUserIdOptions.map((item: any) => {
      const target = values.find((value: any) => item.gmtCreateUserId === value);
      if (target) {
        users.push(item.gmtCreateUserName);
      }
    })
    this.reqFilter.gmtCreateUser = users;
  }

  public handleTabClick(tabNode: any) {
    const tabName = tabNode.name;
    if (tabName === 'applyDetail' && this.tableData.length) {
      this.handleRowClick(this.tableData[0])
    }
  }

  public handlePageSizeChange(pageSize: number) {
    this.tablePage.showCount = pageSize;
    this.getTables();
  }

  public handlePageCurrentChange(currentPage: number) {
    this.tablePage.currentPage = currentPage;
    this.getTables();
  }

  public async handleRowClick(row: any) {
    const id = row.fkStudentId;
    const source = row.source;
    const itemId = row.id;
    try {
      const { data } = await getStuDataApi(id, source);
      const stu = `${data.data.lastName} ${data.data.firstName}`;
      sessionStorage.setItem('tab', 'applyDetail');
      this.activeName = 'applicationList';
      this.$router.push({ name: 'studentInformation', query: { source, itemId , stu }, params: { id } });
    } catch (err) {
      //
    }
  }

  public handleSort(sortStr: string) {
    if (this.reqFilter.orderBy === '') {
      this.reqFilter.orderBy = 'asc';
    } else {
      if (this.reqFilter.orderByColumns !== sortStr) {
        this.reqFilter.orderBy = 'asc';
      } else {
        this.reqFilter.orderBy = this.reqFilter.orderBy === 'asc' ? 'desc' : 'asc';
      }
    }
    this.reqFilter.orderByColumns = sortStr;
    this.resetPageInfo();
    this.getTables();
  }
}
